import { render, staticRenderFns } from "./AssignForm.vue?vue&type=template&id=e09f689c&scoped=true&"
import script from "./AssignForm.vue?vue&type=script&lang=ts&"
export * from "./AssignForm.vue?vue&type=script&lang=ts&"
import style0 from "./AssignForm.vue?vue&type=style&index=0&id=e09f689c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09f689c",
  null
  
)

export default component.exports